import { getUserType } from "./helperMethods";

export const LIBRARY_REQUEST_PREVIEW_TITLE_ANONYMIZED = "Audit Report - Anonymized";
export const LIBRARY_REQUEST_PREVIEW_TITLE_OBSERVATION = "Observation Report";

export function getLibraryRequestPreviewModalTitle(allowFullReportPreview) {
  return allowFullReportPreview
    ? LIBRARY_REQUEST_PREVIEW_TITLE_ANONYMIZED
    : LIBRARY_REQUEST_PREVIEW_TITLE_OBSERVATION;
}

/**
 * Matches Documents/Requests preview authorization (admin + vendor on VQA rows).
 * Pass `canPreview` when the details API already computed it.
 */
export function canShowLibraryRequestPreviewMenuItem({
  userRole,
  documentType,
  requestId,
  canPreview,
} = {}) {
  if (!requestId) return false;
  if (String(documentType || "").toUpperCase() !== "VQA") return false;
  if (canPreview !== undefined && canPreview !== null) {
    return Boolean(canPreview);
  }
  const audience = getUserType(userRole);
  return audience === "admin" || audience === "vendor";
}

export function resolveLibraryRequestPreviewRequestId(libraryRequestId, details) {
  return libraryRequestId ?? details?.request_id ?? null;
}
